import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Skeleton from "@mui/material/Skeleton";

import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";

import apiClient from "../utils/apiClient";
import { useNavigate } from "react-router-dom";
import { useUser, useUserActions } from "../pages/UserContext";
import EditProfileModal from "./data/EditProfileModal";

export default function Navbar({ isMobile, onMenuClick }) {
  const userDetails = useUser();
  const { refetchUser } = useUserActions();
  const name = userDetails?.nama_lengkap;
  const email = userDetails?.email;
  const foto = userDetails?.foto;
  const accessRoleName = userDetails?.accessRoleName;
  const navigate = useNavigate();

  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openEditProfile, setOpenEditProfile] = useState(false);

  useEffect(() => {
    if (foto) {
      const img = new Image();
      img.src = `${process.env.REACT_APP_BACKEND_HOST}/${foto}`;
      img.onload = () => setIsImageLoaded(true);
    }
  }, [foto]);

  const logout = async () => {
    try {
      await apiClient.delete("/logout", { data: { email } });
    } catch (error) {
      console.error("Error logging out", error);
    } finally {
      // Session cookies are cleared server-side regardless of the call's
      // outcome; refetching just lets the shared context pick up the change.
      await refetchUser();
      navigate("/");
    }
  };

  const getFirstName = (fullName) => {
    return fullName ? fullName.split(" ")[0] : "";
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ backgroundColor: "#A92027", padding: "5px 20px" }}>
        <Toolbar>

          {isMobile && (
            <IconButton
              edge="start"
              color="inherit"
              onClick={onMenuClick}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
          )}


          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}></Typography>

          {accessRoleName && (
            <Typography
              variant="subtitle2"
              sx={{
                color: "white",
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                marginRight: "16px",
              }}
            >
              {accessRoleName}
            </Typography>
          )}

          {/* Container Nama + Foto */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              cursor: "pointer",
              padding: "8px 12px",
              borderRadius: "8px",
              transition: "background-color 0.3s",
            }}
            onClick={handleMenu}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.2)")}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
          >
            <Typography variant="subtitle1" color="inherit">
              {getFirstName(name)}
            </Typography>
            
            {!isImageLoaded ? (
              <Skeleton variant="circular" width={42} height={42} animation="wave" />
            ) : (
              <img
                src={`${process.env.REACT_APP_BACKEND_HOST}/${foto}`}
                alt="Profile"
                style={{
                  width: 42,
                  height: 42,
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "2px solid white",
                  transition: "transform 0.3s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              />
            )}
          </div>

          {/* Dropdown Menu */}
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            keepMounted
            disableScrollLock
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            sx={{
              "& .MuiPaper-root": {
                borderRadius: "10px",
                marginTop: "8px",
                padding: "8px",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
              },
            }}
          >
            <MenuItem
              onClick={() => {
                handleClose();
                setOpenEditProfile(true);
              }}
              sx={{ borderRadius: "5px" }}
            >
              Edit Profil
            </MenuItem>
            <MenuItem onClick={logout} sx={{ fontWeight: "bold", borderRadius: "5px" }}>
              Log Out
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      <EditProfileModal
        open={openEditProfile}
        onClose={() => setOpenEditProfile(false)}
      />
    </Box>
  );
}